import ProductConfiguratorAddToCart from '~/themes/base/components/product/ProductConfiguratorAddToCart'

export default {
  extends: ProductConfiguratorAddToCart,
  props: {
    selectedParameters: {
      type: Array,
      default: () => [],
    },
    invalid: Boolean,
    quantity: {
      type: Number,
      default: 1,
    },
    targetId: String,
  },
  computed: {
    cartCount() {
      let count = 0
      const cart = this.$store.state.cart.cartData
      count = (cart.items || []).reduce((acc, item) => {
        if (item.productId === this.product.id) {
          acc += item.amount
        }
        return acc
      }, count)

      return count
    },
    productConfiguratorAddToCartQuantity: {
      get() {
        return this.quantity
      },
      set(value) {
        this.$emit('update:quantity', value)
      },
    },
    isAddToCartDisabled() {
      return this.invalid ||
        !this.product.availability.isAvailable ||
        this.product.availability.stock <= 0 ||
        // Add any other conditions that should disable add to cart
        !this.filledRequiredParameters
    },
  },
  methods: {
    multiplyPrice(price) {
      return price && this.$themeSettings.components.ProductConfigurator.addToCart.multiplyPricesByQuantity
        ? this.productConfiguratorAddToCartQuantity * price
        : price
    },
    updateQuantity(value) {
      this.productConfiguratorAddToCartQuantity = value
      this.$emit('update', value)
    },
  },
}
